import { module } from 'angular';

export const SERVER_GROUP_DETAILS_MODULE = 'spinnaker.ecs.serverGroup.details';
module(SERVER_GROUP_DETAILS_MODULE, [
  require('./serverGroupDetails.ecs.controller.js').name,
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/ecs/serverGroup/details/serverGroupDetails.module.ts